<template>
  <v-dialog v-model="showDialog" width="1400px" persistent>
    <v-form ref="form">
      <v-card>
        <v-card-title>
          <div class="d-flex justify-space-between align-center" style="width: 100%">
            <div class="title-dialog">{{
              $t("invitationsAndCoupons.createNewInvitationTitle")
            }}</div>
            <div class="d-flex align-center copy-source">
              <div class="copy-label">コピー元チケットNo:</div>
              <v-text-field
                v-model="copyFrom"
                class="mx-2 pt-0 copy-input"
                hide-details
                dense
              />
              <v-btn
                class="white--text"
                color="var(--bt__blue)"
                :disabled="!copyFrom"
                @click="copy"
              >コピーして使う</v-btn>
            </div>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row class="pa-10 pb-0">
            <v-col :cols="5" class="pr-8 list-item">
              <div>
                <span class="title-item">{{ $t("common.title") }}</span>
                <v-text-field
                  value="number"
                  :rules="rules.nameTicket"
                  v-model="nameTicket"
                  dense
                />
              </div>
              <div>
                <span class="title-item">{{
                  $t("common.numberOfSheets")
                }}</span>
                <tvos-int-input
                  :max="999"
                  :rules="rules.numberOfTickets"
                  v-model="numberOfTickets"
                  dense
                />
              </div>
              <div>
                <span class="title-item">{{ $t("common.facility") }}</span>
               <v-select
                  multiple
                  :rules="rules.roomTypeIds"
                  v-model="listFac"
                  item-text="name"
                  item-value="id"
                  :items="facilityList"
                  dense
                />
              </div>
              <div>
                <span class="title-item">{{ $t("common.roomType") }}</span>
                <v-select
                  :disabled="selectFacility"
                  :rules="rules.roomTypeIds"
                  v-model="roomTypeIds"
                  :items="listRoomType"
                  item-value="id"
                  item-text="label"
                  multiple
                  dense
                />
              </div>
            </v-col>
            <v-col :cols="3" class="list-item">
              <div>
                <span class="title-item">日付</span>
                <div class="d-flex custom-picker">
                  <v-icon>mdi-calendar-month</v-icon>
                  <v-menu
                    v-model="menuShowDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on }">
                      <div class="custom-btn-picker">
                        <v-btn
                          outlined
                          :rules="rules.fromDate"
                          v-model="fromDate"
                          v-on="on"
                          small
                          class="bg-white--btn mr-5"
                          >{{ formatDate(fromDate) }}</v-btn
                        >
                      </div>
                    </template>
                    <v-date-picker
                      v-model="fromDate"
                      @change="changeFromDate($event)"
                      :first-day-of-week="0"
                      :locale="$i18n.locale"
                      scrollable
                      @input="menuShowDate = false; menuShowTodate = true"
                      class="v-date-picker-custom"
                    ></v-date-picker>
                  </v-menu>
                  <!--  -->
                  <span class="pl-1 pr-1">〜</span>
                  <v-menu
                    v-model="menuShowTodate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on }">
                      <div class="custom-btn-picker">
                        <v-btn
                          outlined
                          v-model="toDate"
                          v-on="on"
                          small
                          class="bg-white--btn mr-5"
                          >{{ formatDate(toDate) }}</v-btn
                        >
                      </div>
                    </template>
                    <v-date-picker
                      :rules="rules.toDate"
                      :min="minToDate"
                      v-model="toDate"
                      :first-day-of-week="0"
                      :locale="$i18n.locale"
                      scrollable
                      @input="menuShowTodate = false"
                      class="v-date-picker-custom"
                    ></v-date-picker>
                  </v-menu>
                  <!--  -->
                </div>
              </div>

              <div class="mt-3 user-or-not">
                <span class="title-item">{{
                  $t("invitationsAndCoupons.reservedPath")
                }}</span>
                <v-checkbox
                  hide-details
                  v-model="bookCallCenter"
                  :label="$t('invitationsAndCoupons.callCenter')"
                ></v-checkbox>
                <v-checkbox
                  v-model="bookSalesRep"
                  hide-details
                  :label="$t('invitationsAndCoupons.sales')"
                ></v-checkbox>
              </div>
              <div class="mt-3">
                <span class="title-item">{{
                  $t("invitationsAndCoupons.dayOfWeek")
                }}</span>
                <div class="d-flex justify-space-between user-or-not">
                  <v-checkbox
                    v-model="monday"
                    hide-details
                    :label="$t('weekdays.monday')"
                  />
                  <v-checkbox
                    v-model="tuesday"
                    hide-details
                    :label="$t('weekdays.tuesday')"
                  />
                  <v-checkbox
                    v-model="wednesday"
                    hide-details
                    :label="$t('weekdays.wednesday')"
                  />
                  <v-checkbox
                    v-model="thursday"
                    hide-details
                    :label="$t('weekdays.thursday')"
                  />
                </div>
                <div class="d-flex justify-space-between user-or-not">
                  <v-checkbox
                    v-model="friday"
                    hide-details
                    :label="$t('weekdays.friday')"
                  />
                  <v-checkbox
                    v-model="saturday"
                    hide-details
                    :label="$t('weekdays.saturday')"
                  />
                  <v-checkbox
                    v-model="sunday"
                    hide-details
                    :label="$t('weekdays.sunday')"
                  />
                  <v-checkbox
                    v-model="holiday"
                    hide-details
                    :label="$t('weekdays.holidays')"
                  />

                </div>
                <div class="d-flex justify-space-between user-or-not">
                  <v-checkbox
                    v-model="dayBeforeHoliday"
                    hide-details
                    :label="$t('weekdays.dayBeforeHoliday')"
                  />
                </div>
              </div>
              <div class="mt-3">
                <span class="title-item">{{
                  $t("invitationsAndCoupons.exclusionDay")
                }}</span>
                <v-menu
                  v-model="excludingDayMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on }">
                    <div class="d-flex align-center">
                      <v-icon>mdi-calendar-month</v-icon>
                      <v-text-field
                        v-model="excludingDay"
                        v-on="on"
                        clearable
                        readonly
                        class="ml-5 pt-0"
                        >{{ excludingDay }}</v-text-field
                      >
                    </div>
                  </template>
                  <v-date-picker
                    multiple
                    v-model="excludingDay"
                    :first-day-of-week="0"
                    :locale="$i18n.locale"
                    scrollable
                    class="v-date-picker-custom"
                  ></v-date-picker>
                </v-menu>
              </div>
              <div class="mt-3 user-or-not">
                <span class="title-item">{{
                  $t("invitationsAndCoupons.userOrNot")
                }}</span>
                <v-checkbox
                  v-model="nightwear"
                  hide-details
                  :label="$t('invitationsAndCoupons.nightwear')"
                ></v-checkbox>
                <v-checkbox
                  v-model="toothbrush"
                  hide-details
                  :label="$t('invitationsAndCoupons.toothbrush')"
                ></v-checkbox>
                <v-checkbox
                  v-model="razor"
                  hide-details
                  :label="$t('invitationsAndCoupons.shaving')"
                ></v-checkbox>
                <v-checkbox
                  v-model="rentalItem"
                  hide-details
                  :label="$t('invitationsAndCoupons.itemAvailableRent')"
                ></v-checkbox>
              </div>
            </v-col>
            <v-col :cols="4" class="pl-8 list-item">
              <div class="user-or-not">
                <span class="title-item">{{
                  $t("invitationsAndCoupons.amountUsed")
                }}</span>
                <v-checkbox
                  @change="getFree($event)"
                  v-model="statusFree"
                  hide-details
                  :label="$t('invitationsAndCoupons.free')"
                ></v-checkbox>
                <div class="d-flex align-end">
                  <v-checkbox
                    style="margin-bottom:15px"
                    v-model="statusNotFree"
                    @change="getNotFree($event)"
                    hide-details
                    :label="$t('invitationsAndCoupons.fixedFree')"
                    class="flex-shrink-0"
                  ></v-checkbox>
                  <span
                    class="ml-2 font-weight-bold flex-shrink-0"
                    style="font-size: 8px; margin-bottom:15px; margin-right: 5px"
                    >{{ $t("invitationsAndCoupons.taxInclude") }}</span
                  >
                  <tvos-int-input
                    :disabled="!statusNotFree"
                    required
                    :class="
                      !statusNotFree ? 'disable': ''
                      "
                      v-model="accommodationPrice"
                      jpy />
                </div>
              </div>
              <div class="mt-3">
                <span class="title-item">{{
                  $t("invitationsAndCoupons.cancelPolicy")
                }}</span>
                <v-select
                  :rules="rules.cancelDeadline"
                  v-model="cancelDeadline"
                  :items="itemCancelDate"
                  dense
                />
              </div>
              <div class="mt-3">
                <span class="title-item">{{
                  $t("invitationsAndCoupons.reservationStartDate")
                }}</span>
                <v-menu
                  v-model="contractStartDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on }">
                    <div class="d-flex align-center">
                      <v-icon>mdi-calendar-month</v-icon>
                      <v-text-field
                        :rules="rules.contractStartDate"
                        v-model="contractStartDate"
                        v-on="on"
                        clearable
                        readonly
                        class="ml-5 pt-0"
                        >{{ contractStartDate }}</v-text-field
                      >
                    </div>
                  </template>
                  <v-date-picker
                    v-model="contractStartDate"
                    :first-day-of-week="0"
                    :locale="$i18n.locale"
                    scrollable
                    @input="contractStartDateMenu = false"
                    class="v-date-picker-custom"
                  ></v-date-picker>
                </v-menu>
              </div>
              <div class="mt-5">
                <span class="title-item">{{
                  $t("invitationsAndCoupons.reservationPeriod")
                }}</span>
                <div class="d-flex justify-space-between align-baseline">
                  <div>宿泊</div>
                  <div style="width: 80px">
                    <v-select
                      :rules="rules.bookingFromMonths"
                      v-model="bookingFromMonths"
                      :items="bookingFromMonthsSelect"
                      dense
                      width="80"
                    />
                  </div>
                  <div>か月前</div>
                  <div style="width: 80px">
                    <v-select
                      :rules="rules.bookingFromDays"
                      v-model="bookingFromDays"
                      :items="bookingFromDaysSelect"
                      dense
                    />
                  </div>
                  <div>日前</div>
                </div>
              </div>
              <div class="mt-3">
                <span class="title-item">{{
                  $t("invitationsAndCoupons.amountRightReserved")
                }}</span>
                <tvos-int-input v-model="assetValue" jpy class="mb-9" />
              </div>
            </v-col>
          </v-row>
          <v-row class="px-10 list-item">
            <div style="width: 100%">
              <span class="title-item">{{ $t("common.remark") }}</span>
              <v-text-field v-model="notes" dense />
            </div>
          </v-row>
        </v-card-text>
        <v-card-text class="mt-5">
          <v-row class="mt-1">
            <v-col :cols="6" class="d-flex justify-start"> </v-col>
            <v-col :cols="6" class="d-flex justify-end">
              <v-btn
                color="var(--bt__red)"
                class="mr-3 d-flex align-center btn_status white--text"
                @click="closeDialog"
              >
                <v-icon class="white--text"> mdi-close </v-icon>
                {{ $t("common.close") }}
              </v-btn>
              <v-btn
                class="white--text"
                color="var(--bt__blue)"
                @click="actionCreateNew()"
              >
                {{ $t("common.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { formatDate } from '@/constants/functions'
import { mapMutations, mapActions } from 'vuex'
import { FACLILITY_LIST } from '@/api/graphql/guestRoomDailyReport/create-booking.js'
import gql from 'graphql-tag'

export default {
  name: 'CreateInvitationAndCoupon',
  props: {
    listBookingTicketType: Object,
    showDialog: Boolean,
  },
  data () {
    return {
      listFac: [],
      statusFree: false,
      statusNotFree: true,
      facilityList: [],
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
      holiday: false,
      // 祝前 defaults to unchecked in the create UI (DB column default is true).
      dayBeforeHoliday: false,
      assetValue: 0,
      notes: '',
      cancelDeadline: null,
      bookingFromDays: null,
      bookingFromMonths: null,
      roomTypeIds: [],
      nightwear: false,
      toothbrush: false,
      bookCallCenter: false,
      bookSalesRep: false,
      razor: false,
      rentalItem: false,
      accommodationPrice: null,
      minFromDate: new Date().toISOString().substr(0, 10),
      minToDate: new Date().toISOString().substr(0, 10),
      fromDate: new Date().toISOString().substr(0, 10),
      toDate: new Date().toISOString().substr(0, 10),
      menuShowDate: false,
      menuShowTodate: false,
      nameTicket: '',
      numberOfTickets: null,
      copyFrom: null,
      rules: {
        nameTicket: [
          (v) => !!v || this.$t('rules.isRequired'),
          (v) => v?.length < 256 || this.$t('rules.isInvalid')
        ],
        numberOfTickets: [(v) => !!v || this.$t('rules.isRequired'),
          (v) => Number.isInteger(parseInt(v)) || this.$t('facility.rentalList.rules.isNumber')],
        roomTypeIds: [(v) => v.length > 0 || this.$t('rules.isRequired')],
        fromDate: [(v) => !!v || this.$t('rules.isRequired'),
          (v) => v >= new Date().toISOString().substr(0, 10) || this.$t('rules.isInvalid')
        ],
        toDate: [(v) => !!v || this.$t('rules.isRequired')],
        excludingDay: [(v) => !!v || this.$t('rules.isRequired')],
        accommodationPrice: [(v) => !!v || this.$t('rules.isRequired')],
        cancelDeadline: [(v) => !!v || this.$t('rules.isRequired')],
        contractStartDate: [(v) => !!v || this.$t('rules.isRequired')],
        bookingFromDays: [(v) => typeof v === 'number' || this.$t('rules.isRequired')],
        bookingFromMonths: [(v) => typeof v === 'number' || this.$t('rules.isRequired')],
        assetValue: [(v) => !!v || this.$t('rules.isRequired')]
      },
      menuDate: [],
      listDate: [
        { id: 1, date: new Date().toISOString().substr(0, 10) },
        { id: 2, date: new Date().toISOString().substr(0, 10) }
      ],
      excludingDayMenu: false,
      excludingDay: [],
      contractStartDateMenu: false,
      contractStartDate: new Date().toISOString().substr(0, 10),
      taxIncludeFee: 0,
      amountFee: 0
    }
  },

  computed: {
    itemCancelDate () {
      const data = [...Array(100)].map((_, ind) => ({
        text: `宿泊日から${ind + 1}日前以降`,
        value: ind + 1
      }))
      return data
    },
    bookingFromDaysSelect () {
      return [...Array(101)].map((_, ind) => ({
        text: ind,
        value: ind
      }))
    },
    bookingFromMonthsSelect () {
      return [...Array(7)].map((_, ind) => ({
        text: ind,
        value: ind
      }))
    },
    listRoomType () {
      return this.facilityList
        .filter(f => this.listFac.includes(f.id))
        .map(f => f.roomTypes.map(rt => ({
          ...rt,
          label: `${f.name} ${rt.name}`,
        })))
        .flat()
    },
    selectFacility () {
      return this.listFac.length === 0
    },
  },

  created () {
  },
  async mounted () {
    this.setToDate()
    await this.getFacilityList()
    await this.fetchData()
  },

  methods: {
    ...mapMutations({ setInvitationTicket: 'setInvitationTicket' }),
    ...mapActions({
      actionCreate: 'createBookingTickets',
      actionGetBookingTicketType: 'actionGetBookingTicketType'
    }),

    fetchData () {
      if (this.listBookingTicketType) {
        this.populateFromTicket(this.listBookingTicketType)
      }
    },

    populateFromTicket (data) {
      this.listFac = []
      this.roomTypeIds = []
      this.excludingDay = []
      this.nameTicket = data.name
      this.numberOfTickets = data.computed.issuedCount
      for (let i = 0; i < data.roomTypes.length; i++) {
        if (!this.listFac.includes(data.roomTypes[i].roomType.facility.id)) {
          this.listFac.push(data.roomTypes[i].roomType.facility.id)
        }
        this.roomTypeIds.push(data.roomTypes[i].roomType.id)
      }
      for (let i = 0; i < data.exceptDates.length; i++) {
        this.excludingDay.push(data.exceptDates[i].exceptDate)
      }
      this.fromDate = data.availableFromDate
      this.toDate = data.availableToDate
      this.bookCallCenter = data.bookCallCenter
      this.bookSalesRep = data.bookSalesRep
      this.monday = data.availableMonday
      this.tuesday = data.availableTuesday
      this.wednesday = data.availableWednesday
      this.thursday = data.availableThursday
      this.friday = data.availableFriday
      this.saturday = data.availableSaturday
      this.sunday = data.availableSunday
      this.holiday = data.availableHoliday
      this.dayBeforeHoliday = data.availableDayBeforeHoliday
      this.nightwear = data.nightwear
      this.toothbrush = data.toothbrush
      this.razor = data.razor
      this.rentalItem = data.rentalItem
      this.accommodationPrice = data.accommodationPrice
      this.cancelDeadline = data.cancelDeadline
      this.contractStartDate = data.bookingFromDate
      this.bookingFromDays = data.bookingFromDays
      this.bookingFromMonths = data.bookingFromMonths
      this.assetValue = data.assetValue
      this.notes = data.notes
      this.statusFree = !this.accommodationPrice
      this.statusNotFree = !this.statusFree
    },

    async copy () {
      const data = await this.actionGetBookingTicketType(this.copyFrom)
      if (data) {
        this.populateFromTicket(data)
      }
    },

    resetForm () {
      this.$refs.form.resetValidation()
      this.monday = false
      this.tuesday = false
      this.wednesday = false
      this.thursday = false
      this.friday = false
      this.saturday = false
      this.sunday = false
      this.holiday = false
      this.dayBeforeHoliday = false
      this.assetValue = 0
      this.cancelDeadline = null
      this.bookingFromDays = null
      this.bookingFromMonths = null
      this.roomTypeIds = null
      this.nightwear = false
      this.toothbrush = false
      this.exceptDates = []
      this.bookingFromDate = ''
      this.bookCallCenter = false
      this.bookSalesRep = false
      this.razor = false
      this.rentalItem = false
      this.accommodationPrice = 0
      this.fromDate = new Date().toISOString().substr(0, 10)
      this.toDate = new Date().toISOString().substr(0, 10)
      this.menuShowDate = false
      this.menuShowTodate = false
      this.nameTicket = ''
      this.numberOfTickets = null
      this.listFac = []
      this.copyFrom = null
      this.setToDate()
    },

    getFree (event) {
      this.statusFree = event
      this.statusNotFree = !event
      this.accommodationPrice = 0
    },

    getNotFree (event) {
      this.statusNotFree = event
      this.statusFree = !event
      this.accommodationPrice = 0
    },

    changeFromDate (event) {
      const result = new Date(event)
      const addRes = new Date(event).setDate(result.getDate() + 1)
      const date = new Date(addRes)
      this.minToDate = date.toISOString().substr(0, 10)
      this.toDate = date.toISOString().substr(0, 10)
    },
    setToDate () {
      const result = new Date()
      this.toDate = new Date().setDate(result.getDate() + 1)
      const date = new Date(this.toDate)
      this.toDate = date.toISOString().substr(0, 10)
      this.minToDate = date.toISOString().substr(0, 10)
    },

    formatDate,

    async getFacilityList () {
      await this.$apollo
        .query({
          query: gql`${FACLILITY_LIST}`
        })
        .then((data) => {
          this.facilityList = data.data.facilityList
        })
        .catch((error) => {
          console.error(error)
        })
    },

    async actionCreateNew () {
      if (this.$refs.form.validate()) {
        const invitationTicket = {
          name: this.nameTicket,
          numberOfTickets: this.numberOfTickets,
          roomTypeIds: this.roomTypeIds,
          availableFromDate: this.fromDate,
          availableToDate: this.toDate,
          bookCallCenter: this.bookCallCenter,
          bookSalesRep: this.bookSalesRep,
          monday: this.monday,
          tuesday: this.tuesday,
          wednesday: this.wednesday,
          thursday: this.thursday,
          friday: this.friday,
          saturday: this.saturday,
          sunday: this.sunday,
          holiday: this.holiday,
          dayBeforeHoliday: this.dayBeforeHoliday,
          exceptDates: this.excludingDay,
          nightwear: this.nightwear,
          toothbrush: this.toothbrush,
          rentalItem: this.rentalItem,
          razor: this.razor,
          accommodationPrice: this.accommodationPrice,
          cancelDeadline: this.cancelDeadline,
          bookingFromDate: this.contractStartDate,
          bookingFromDays: this.bookingFromDays,
          bookingFromMonths: this.bookingFromMonths,
          assetValue: this.assetValue,
          notes: this.notes,
        }
        this.setInvitationTicket({ invitationTicket: invitationTicket })
        await this.actionCreate()
        this.closeDialog()
        this.resetForm()
      }
    },

    closeDialog () {
      this.resetForm()
      this.$emit('close')
    }
  },

  components: {
  }
}
</script>

<style scoped lang="scss">
.disable {
  pointer-events: none;
}
.list-item::v-deep {
  div {
    font-size: 14px;
    span {
      &:first-child {
        font-size: 10px !important;
        font-weight: bold !important;
      }
      &.v-btn__content {
        font-size: 13px !important;
        font-weight: unset !important;
      }
    }
    .v-label {
      font-size: 14px;
    }
    .v-input--checkbox {
      margin: 0 0;
    }
  }
}

::v-deep {
  .v-input--selection-controls__input .v-label .theme--light {
    color: red !important
  }
  .custom-picker .v-size--small {
    color: #ffffff;
    border: solid 1px #000000;
  }
  .custom-picker .v-btn__content {
    color: #000000;
  }
  .custom-btn-picker .v-size--small {
    margin: 0 !important;
    width: 115px !important;
  }
  .list-item div span.v-btn__content {
    font-size: 10px !important;
  }
  .mdi-calendar-month::before {
    color: #333333;
  }
  .user-or-not .v-label {
    color: #000000;
  }
  .v-list-item__title {
    font-size: 14px !important;
  }
  .v-list-item__action {
    margin: 0;
  }
}
.size-text-notice {
  font-size: 10px;
}
.title-dialog {
  font-size: 20px;
  font-weight: bold !important;
  color: #000000;
}
.copy-source {
  font-size: 14px;
  .copy-label {
    white-space: nowrap;
  }
  .copy-input {
    width: 120px;
  }
}
.title-item {
  color: #212121;
}
</style>
